export type LogoIconProps = {
  className?: string;
} & React.SVGProps<SVGSVGElement>;

export function LogoIcon({ className }: LogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 666.7 666.7"
      className={`icon ${className || ''}`}
    >
      <path fill="currentColor" d="M666.7 666.7H0V0h666.7v666.7"></path>
      <path
        fill="#fff"
        d="M432.3 165.2H153.8c-3.7 0-5.8 1.8-5.8 5.8v325.3c0 2.9 1 5.4 5 5.4h211.1c3.6 0 5.4-2.5 5.4-5.6V304.9h-14c-2.7 0-2.8-3-2.8-3v-36.4s0-2.6 2.7-2.6h14c0-39.6 16.6-81.6 63.1-94 2-.7 1.7-3.7-.2-3.7"
      ></path>
      <path
        fill="#fff"
        d="M508.7 301.9v-36.2c-.1-.6-.5-2.8-3-2.8h-32c0-43 27-50.4 42.7-51 .3 0 2.3.2 2.3-1.9v-43.2c0-1.9-1.9-1.8-2.3-1.8-45.3.7-90 32.6-90 98h-18.7c-3.3 0-3 3.1-3 3.1v36s0 2.8 3 2.8h18.7v192.8s.2 4 4.4 4h38c4.9 0 5-4.4 5-4.4V305h31.5c2.2 0 3.4-1.4 3.4-3"
      ></path>
    </svg>
  );
}

export function SuccessIcon({ className, ...props }: LogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`icon ${className || ''}`}
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="currentColor"></circle>
      <path
        fill="#fff"
        d="M8.6 13.3l-.4-.2-2.5-2.5a.6.6 0 010-.8c.2-.2.5-.2.8 0l2 2 5-4.9c.3-.2.6-.2.9 0 .2.2.2.6 0 .8L9 13.1l-.4.2z"
      ></path>
    </svg>
  );
}

export default LogoIcon;
